import { Box, Button, Modal, Text } from '@fozito/common-ui';
import { delay } from 'lodash';
import cashierApis from 'modules/POS/services/apis';
import { forwardRef, useImperativeHandle, useRef, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { IResponseData } from 'services/response';
import { setPageLoading } from 'widgets/PageLoading';
import { cashierCtrl } from '../../cashier.controller';
import { FooterActions } from '../../components/styles';
type Props = {
};
type Ref = {
  open: () => void;
};
const useModalRef = () => useRef<Ref>(null);
const ModalGetTicketNumber = forwardRef<Ref, Props>(({ }, ref) => {
  const { shop_id = '' } = useParams<{ shop_id: string }>();
  const navigate = useNavigate();
  const [ticketNumber, setOpen] = useState<number | null>(null);
  const onClose = () => setOpen(null);
  const onOpen: Ref['open'] = async () => {
    setPageLoading(true);
    try {
      const res: IResponseData<number> = await cashierApis.getNumberTicket();
      if (res.data.data) {
        setOpen(res.data.data);
      }
    } catch (error) {
    } finally {
      setPageLoading(false);
    }
  };

  useImperativeHandle(ref, () => ({
    open: onOpen
  }));

  const handleDone = () => {
    onClose();
    navigate(`/store/${shop_id}`);
    delay(() => cashierCtrl.generateNewTicket(), 500);
  };
  const handleCancel = () => {
    navigate(`/store/${shop_id}`);
    onClose();
  };

  return (
    <Modal title='Please Confirm' open={!!ticketNumber} onClose={onClose} width={700} onOk={handleDone}>
      <Box display='flex' padding={24} textAlign='center' justifyContent='center' gap={4}>
        <Text title_h6_20_regular>Do you like to create the ticket </Text>
        <Box background={'#232F3E'} paddingRight={2} paddingLeft={2} borderRadius={4}>
          <Text title_h6_20_regular style={{ color: '#fff', fontWeight: '600' }}>
            #{ticketNumber || 0}
          </Text>
        </Box>
      </Box>
      <FooterActions>
        <Button style={{ flex: 1 }} onClick={handleCancel} type_cancel><span>Close</span></Button>
        <Button style={{ flex: 1 }} onClick={handleDone} type_primary><span>OK</span></Button>
      </FooterActions>
    </Modal>
  );
});

ModalGetTicketNumber.displayName = 'ModalGetTicketNumber';

const useModalGetTicketNumber = (): [React.RefObject<Ref>, JSX.Element] => {
  const ref = useModalRef();
  const context = <ModalGetTicketNumber ref={ref} />;
  return [ref, context];
};
export default useModalGetTicketNumber;